var React = require('react');

function TvGuide (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"6","y":"18","width":"8","height":"8","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("rect",{"x":"18","y":"18","width":"8","height":"8","stroke":"currentColor","strokeWidth":"2","key":1}),React.createElement("rect",{"x":"6","y":"6","width":"8","height":"8","fill":"currentColor","stroke":"currentColor","strokeWidth":"2","key":2}),React.createElement("rect",{"x":"18","y":"6","width":"8","height":"8","stroke":"currentColor","strokeWidth":"2","key":3})]);
}

TvGuide.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = TvGuide;

TvGuide.default = TvGuide;
